<template>
  <div id="root">
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-lg-12 col-sm-12">
          <h6>
            Total
            <span class="NA" v-if="reportingData.data.totalReportingPercentage == 'NA'">NA</span>
            <span v-if="reportingData.data.totalReportingPercentage != 'NA'" class="percent">
              {{ reportingData.data.totalReportingPercentage }}%
            </span>
            <span v-if="reportingData.data.totalReportingPercentage != 'NA'">-</span>
            <CircleButton
              v-if="reportingData.data.totalReportingPercentage != 'NA'"
              icon
              round
              disabled
              :class="{
                'number': true,
                'green': reportingData.data.totalReportsMissing == 0,
                'red': reportingData.data.totalReportsMissing > 0,
              }"
            >
              <span
                v-if="reportingData.data.totalReportsMissing != 'NA'"
              >
                {{ reportingData.data.totalReportsMissing }}
              </span>
            </CircleButton>
          </h6>
        </div>
      </div>
      <div class="row">
        <div
          class="col-md-6 col-lg-4 col-sm-12 discipleTree"
          v-for="chainData in reportingData.data.chains"
          :key="chainData.rootPersonId"
        >
          <h6>
            {{ chainData.rootPersonName }}
            <span class="NA" v-if="chainData.reportingPercentage == 'NA'">
              <CircleButton
                icon
                round
                disabled
                class="transparent-button"
              >
                NA
              </CircleButton>
            </span>
            <span v-if="chainData.reportingPercentage != 'NA'" class="percent">
              {{ chainData.reportingPercentage }}%
            </span>
            <span v-if="chainData.reportingPercentage != 'NA'">-</span>
            <CircleButton
              v-if="chainData.reportingPercentage != 'NA'"
              icon
              round
              disabled
              :class="{
                'number': true,
                'green': chainData.reportsMissing == 0,
                'red': chainData.reportsMissing > 0,
              }"
            >
              <span
                v-if="chainData.reportsMissing != 'NA'"
              >
                {{ chainData.reportsMissing }}
              </span>
            </CircleButton>
          </h6>
          <div
            class="disciple clickable-paragraph"
            v-for="disciple in chainData.chain"
            :key="disciple.personId"
            @click="goToPersonProfile(disciple.personId)"
          >
            {{ disciple.discipleName }}
            <span class="NA" v-if="disciple.reportingPercentage == 'NA'">
              <CircleButton
                icon
                round
                disabled
                class="transparent-button"
              >
                NA
              </CircleButton>
            </span>
            <span v-if="disciple.reportingPercentage != 'NA'" class="percent">
              {{ disciple.reportingPercentage }}%
            </span>
            <span v-if="disciple.reportingPercentage != 'NA'">-</span>
            <CircleButton
              v-if="disciple.reportingPercentage != 'NA'"
              icon
              round
              disabled
              :class="{
                'number': true,
                'green': disciple.reportsMissing == 0,
                'red': disciple.reportsMissing > 0,
              }"
            >
              <span
                v-if="disciple.reportsMissing != 'NA'"
              >
                {{ disciple.reportsMissing }}
              </span>
            </CircleButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CircleButton from '../UIComponents/Button.vue';

export default {
    name: 'ReportingPercentagesTable',
    components: {
        CircleButton
    },
    data() {
        return {
        };
    },
    props: {
        reportingData: {
            type: [Array, Object],
            default: null
        },
    },
    methods: {
        goToPersonProfile(id) {
            this.$router.push({ name: 'PersonShow', params: { id } });
        }
    },

};
</script>

<style scoped>
.container {
  max-width: 100%;
  text-align: center;
}
.clickable-paragraph {
  border: 1px solid lightgray;
  background-color: white;
  padding: 20px;
}
.discipleTree {
  margin: 20px 0;
}
.green {
  background-color: #6cc070 !important;
  opacity: 1 !important;
  color: white;
  margin: 0px;
}
.red {
  background-color: #F56C6C !important;
  opacity: 1 !important;
  color: white;
  margin: 0px;
}
.percent{
  margin-left: 20px;
  margin-right: 5px;
}
.number{
  margin-left: 5px;
}
.NA {
  color: gray;
  margin-left: 15px;
}
.transparent-button{
  background-color: transparent !important;
  opacity: 1 !important;
  color: gray;
  margin: 0px;
}
.green:hover, .red:hover, .transparent-button:hover {
  cursor: auto !important;
}
</style>
